import React, { useState, useEffect } from "react";
import {
  Alert,
  Button,
  ButtonGroup,
  Container,
  Card,
  Col,
  Form,
  Row,
  Modal,
  Spinner,
  Dropdown,
  Tooltip,
  OverlayTrigger,
  ListGroup,
} from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";

import CustomNavbar from "../../../components/CustomNavbar";
import CustomTable from "../../../components/CustomTable";
import CustomPagint from "../../../components/CustomPagint";

import {
  getDisciplinaryActionTypes,
  saveDisciplinaryActionTypes,
  editDisciplinaryActionTypes,
  deleteDisciplinaryActionTypes,
} from "../../../redux/Modulo_Sanciones/Disciplinary_Action_Types/actions";

import messages from "../../../redux/messages";
// import SidebarBoarding from "../../../components/OnBoarding_OffBoarding/sidebar_On_Off_Boarding";
import SidebarBoarding from "../../../components/SidebarDashboard";

const Disciplinary_Action_Types = (props) => {
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [currentPage, setCurrentPage] = useState(1);
  const [edit, setEdit] = useState(false);
  const [index, setIndex] = useState(0);
  const [editItem, setEditItem] = useState({});
  const [showModal, setShowModal] = useState(false);
  const [filter, setFilter] = useState("");
  const [validated, setValidated] = useState(false);
  const [show, setShow] = useState(false);
  const [mostrarJefe, setMostrarJefe] = useState(false);
  const [tipoBusqueda, setTipoBusqueda] = useState({
    id: "nombre",
    desc: "Nombre",
  });

  const userRoles = useSelector((store) => store.auth.userRoles);

  const dispatch = useDispatch();

  const filters = [
    { id: "nombre", desc: "Nombre" },
    { id: "descripcion", desc: "Descripción" },
  ];

  const {
    loading,
    saveLoading,
    disciplinaryActionTypesLength,
    disciplinaryActionTypes,
    disciplinaryActionTypesError,
    formError,
  } = useSelector((store) => store.disciplinaryActionType);
  const pages = Math.ceil(disciplinaryActionTypesLength / limit);

  const columns = [
    {
      Header: "Nombre",
      accessor: "nombre",
    },
    {
      Header: "Descripcion",
      accessor: "descripcion",
    },
    {
      Header: "Fecha creación",
      accessor: "fecha_creacion",
      Filter: "",
      Cell: (value) => (
        <div>
          {moment(value.row.original.fecha_creacion).format("DD/MM/YYYY")}
        </div>
      ),
    },
    {
      id: "customButtons",
      Filter: "",
      Cell: (value) => (
        <div className="btn-group" role="group">
          <Button
            size="sm"
            variant="link"
            type="button"
            onClick={() => onEdit(value.row.original, value.row.index)}
          >
            <i className="material-icons">edit</i>
          </Button>
          <Button
            size="sm"
            className="text-danger"
            variant="link"
            type="button"
            onClick={() => onDelete(value.row.original.id, value.row.index)}
          >
            <i className="material-icons">close</i>
          </Button>
        </div>
      ),
    },
  ];

  // Métodos
  const getADisciplinaryAction = (offs = offset, lim = limit, filt = filter) =>
    dispatch(
      getDisciplinaryActionTypes({
        offset: offs,
        limit: lim,
        tipo_busqueda: tipoBusqueda.id,
        filter: filt,
      })
    );

  useEffect(() => {
    getADisciplinaryAction();
  }, []);

  const addArea = () => {
    setMostrarJefe(false);
    setShowModal(true);
    setEdit(false);
    setValidated(false);
  };

  const onEdit = (item, index) => {
    setMostrarJefe(item.mostrar_jefe);
    setIndex(index);
    setEdit(true);
    setEditItem(item);
    setShowModal(true);
    setValidated(false);
  };

  const onSearch = (e) => {
    e.preventDefault();
    setFilter(e.target.filter.value);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getADisciplinaryAction(oOffset, limit, e.target.filter.value);
  };
  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.currentTarget;
    if (form.checkValidity() === false) {
      setValidated(true);
      return;
    }

    const req = {
      nombre: e.target.nombre.value,
      descripcion: e.target.descripcion.value,
      mostrar_jefe: mostrarJefe,
      fecha_creacion: moment(new Date()).format("YYYY-MM-DD"),
    };

    if (!edit) {
      dispatch(saveDisciplinaryActionTypes(req));
      e.target.reset();
      setShowModal(false);
    } else {
      dispatch(editDisciplinaryActionTypes(req, editItem.id, index));
      setShowModal(false);
    }
  };

  const seeAll = () => {
    const oSearch = "";
    setFilter(oSearch);
    const oOffset = 0;
    setOffset(oOffset);
    setCurrentPage(1);
    getADisciplinaryAction(oOffset, limit, oSearch);
  };

  const onDelete = (id, index) => {
    if (window.confirm(messages.preguntaEliminar)) {
      dispatch(deleteDisciplinaryActionTypes(id, index));
      window.alert("Se borro este archivo");
    }
  };

  const onShowSidebar = () => setShow(show ? false : true);

  return (
    <>
      <CustomNavbar type={"dashboard"} onShowSidebar={onShowSidebar} />
      <SidebarBoarding show={show} onShowSidebar={onShowSidebar} />
      <div className="custom-wrapper">
        <Container fluid>
          <div className="my-1 pl-md-4 pr-md-3 pl-2 pr-1 d-flex flex-wrap justify-content-between align-items-center">
            <h6 className="font-weight-bold text-uppercase">
              Tipo de acción disciplinaria
            </h6>
            <Form onSubmit={onSearch}>
              <Row className="justify-content-end align-items-center flex-nowrap">
                <Col>
                  <h6>
                    <b>Búsqueda por: {tipoBusqueda.desc}</b>
                  </h6>
                </Col>
                <Col xs="auto">
                  <Form.Control
                    name="filter"
                    id="filter"
                    placeholder="Buscar"
                    className="rounded-pill form-control-sm"
                    type="search"
                  ></Form.Control>
                </Col>
                <Col xs="auto">
                  <ButtonGroup>
                    <Button
                      onClick={() => seeAll()}
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                    >
                      <i className="material-icons">list</i>
                    </Button>
                    <ButtonGroup>
                      <OverlayTrigger
                        placement="auto"
                        overlay={
                          <Tooltip {...props}>Seleccionar Filtrado</Tooltip>
                        }
                      >
                        <Dropdown className="ml-3 mr-3">
                          <Dropdown.Toggle
                            variant="light"
                            className="btn-sm font rounded-pill"
                          >
                            <i className="material-icons">filter_list</i>
                          </Dropdown.Toggle>
                          <Dropdown.Menu>
                            {filters.map((item) => (
                              <Dropdown.Item
                                onClick={() => setTipoBusqueda(item)}
                                key={item.id}
                              >
                                {item.desc}
                              </Dropdown.Item>
                            ))}
                          </Dropdown.Menu>
                        </Dropdown>
                      </OverlayTrigger>
                    </ButtonGroup>
                    <Button
                      variant="light"
                      size="sm"
                      className="rounded-circle"
                      onClick={() => addArea()}
                    >
                      <i className="material-icons">add</i>
                    </Button>
                  </ButtonGroup>
                </Col>
              </Row>
            </Form>
          </div>
          {loading ? (
            <div className="d-flex justify-content-center">
              <Spinner
                animation="border"
                role="status"
                className="d-flex justify-content-center"
              />
            </div>
          ) : (
            disciplinaryActionTypesLength > 0 && (
              <>
                <Card className="border-0">
                  <Card.Body className="px-1 px-sm-2">
                    <CustomTable
                      columns={columns}
                      data={disciplinaryActionTypes}
                    />
                  </Card.Body>
                </Card>
                <CustomPagint
                  limit={limit}
                  setLimit={setLimit}
                  offset={offset}
                  setOffset={setOffset}
                  currentPage={currentPage}
                  setCurrentPage={setCurrentPage}
                  dataLenght={disciplinaryActionTypesLength}
                  pages={pages}
                  pagFunc={getADisciplinaryAction}
                />
              </>
            )
          )}
          {!loading &&
            disciplinaryActionTypesLength === 0 &&
            disciplinaryActionTypesError === "" && (
              <Alert variant="info" className="my-4">
                Aún no hay registros, comience agregando algunos
              </Alert>
            )}
          {!!disciplinaryActionTypesError && (
            <Alert variant="danger" className="mt-4 mb-1 mx-3">
              {disciplinaryActionTypesError}
            </Alert>
          )}
        </Container>
      </div>
      <Modal show={showModal} onHide={() => setShowModal(false)}>
        <Form onSubmit={onSubmit} noValidate validated={validated}>
          <Modal.Header closeButton>
            <Modal.Title className="text-muted">
              {edit
                ? "Editar Tipo de acción disciplinaria"
                : "Crear Tipo de acción disciplinaria"}
            </Modal.Title>
          </Modal.Header>
          <Modal.Body>
            {!!formError && (
              <Alert variant="danger" className="mt-4 mb-1 mx-3">
                {formError}
              </Alert>
            )}
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Nombre
              </Form.Label>
              <Form.Control
                name="nombre"
                className="rounded-pill"
                required
                type="text"
                defaultValue={edit ? editItem.nombre : null}
                pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+$"
                placeholder="Nombre del tipo de acción disciplinaria"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite letras,numeros y los siguientes caracteres
                @$¿?¡\-_%#
              </Form.Control.Feedback>
            </Form.Group>
            <Form.Group as={Col} className="mb-3">
              <Form.Label column sm="12" md="12">
                Descripción:
              </Form.Label>
              <Form.Control
                as="textarea"
                required
                name="descripcion"
                defaultValue={edit ? editItem.descripcion : null}
                pattern="^[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+(\s*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]*)*[a-zA-ZÀ-ÿ\u00f1\u00d1.0-9'{}().:,;&@$¿?¡/\-_%#]+$"
                placeholder="Descripción del tipo de acción disciplinaria"
              ></Form.Control>
              <Form.Control.Feedback type="invalid">
                **Campo requerido
              </Form.Control.Feedback>
              <Form.Control.Feedback type="invalid">
                **Solo admite letras,numeros y los siguientes caracteres
                @$¿?¡\-_%#
              </Form.Control.Feedback>
            </Form.Group>
            <ListGroup variant="flush">
              <ListGroup.Item className="d-flex justify-content-between aling-items-center">
                <label>¿Mostrar jefe?</label>
                <Form.Check
                  defaultChecked={mostrarJefe}
                  onChange={() => {
                    setMostrarJefe(!mostrarJefe);
                  }}
                  type="switch"
                  name="mostrar_jefe"
                  id="mostrar_jefe"
                />
              </ListGroup.Item>
            </ListGroup>
          </Modal.Body>
          <Modal.Footer>
            <Button
              className="rounded-pill"
              variant="secondary"
              onClick={() => setShowModal(false)}
            >
              Cerrar
            </Button>
            <Button
              className="rounded-pill"
              disabled={saveLoading}
              variant="primary"
              type="submit"
            >
              {saveLoading && (
                <Spinner
                  className="mr-2"
                  as="span"
                  animation="border"
                  size="sm"
                  role="status"
                  aria-hidden="true"
                />
              )}
              Guardar
            </Button>
          </Modal.Footer>
        </Form>
      </Modal>
    </>
  );
};

export default Disciplinary_Action_Types;
